import type {
    CoverableChangesDTO,
    CoverableDTO,
    DiffDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import type { OPCRowInformation } from '../../../../config/flavourConfig';
import type { CarDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/mvp';
import { getCoverableDiffsDTO, isChangeTypeAvailable } from '../../../../utils/opcChangesUtil';
import { AdjustItemKeys } from '../adjustDetails';

const LINE_PREFIX_MVP = 'MVP';
const YEARLY_MILEAGE_ATTRIBUTE_NAME = 'YearlyMileage';

const getCarAdjustDetailsConfig = (
    car: CarDTO,
    getHippoText: (resourceKey: string) => string,
    changes: DiffDTO[],
    isOpc: boolean
): OPCRowInformation[] => {
    const coverableId = car.fixedId ?? '';
    const isYearlyMilegeAvailable = isChangeTypeAvailable(
        { type: 'attribute', attributeFieldName: YEARLY_MILEAGE_ATTRIBUTE_NAME },
        changes
    );

    return [
        {
            key: AdjustItemKeys.MVP_CAR_YEARLY_MILEAGE,
            name: getHippoText('DSS-EXPANDED-SHOPPING-BASKET-ADJUST-YOUR-DETAILS-SUBHEADER'),
            fieldValue: `${car.yearlyMileage} km`,
            isAdjustableItem: true,
            labelType: 'normal',
            opcInfo: {
                changeType: 'attribut',
                productName: 'top_mvp_car',
                coverableId,
                attribute: 'carYearlyMileage'
            },
            hidden: isOpc && !isYearlyMilegeAvailable
        }
    ];
};

const getVehicleAdjustDetailsConfig = (
    vehicle: CoverableDTO,
    getHippoText: (resourceKey: string) => string,
    isOpc: boolean,
    coverableChangesDTO: CoverableChangesDTO[]
): OPCRowInformation[] => {
    const changes = getCoverableDiffsDTO(
        coverableChangesDTO,
        LINE_PREFIX_MVP,
        vehicle.fixedId ?? ''
    );

    switch (vehicle.flavourName) {
        case 'Bilforsikring':
            return getCarAdjustDetailsConfig(vehicle as CarDTO, getHippoText, changes, isOpc);
        default:
            throw new Error('Coverable is not vehicle flavour');
    }
};

export default getVehicleAdjustDetailsConfig;
